const CHAT_ROOMS_SCOPE = "chat-rooms";

/**
 * Query-cache key that marks a room as archived this session (persistent). Used
 * to redirect away instantly when the room is re-opened, with no fetch
 * round-trip and no archived-room flash on screen.
 */
export const archivedChatRoomQueryKey = (uuid: string) => [
  CHAT_ROOMS_SCOPE,
  "archived",
  uuid,
];
